import config from 'config/global';

const CLOUDINARY_SHARPEN = 'e_sharpen:80';
const CLOUDINARY_QUALITY = 'q_auto:best';
const CLOUDINARY_CROPPING = 'c_fill';
const CLOUDINARY_HEIGHT = 'h_';
const CLOUDINARY_WIDTH = 'w_';
const CLOUDINARY_KEEP_ATTRIBUTION = 'fl_keep_attribution';

const GALLERY_PHOTO_SIZES = { height: 45, width: 36 };
const MAIN_PHOTO_SIZES = { height: 101, width: 81 };

export enum ImageLocation {
  GalleryPhoto = 'galleryPhoto',
  MainPhoto = 'mainPhoto',
}

export function getImageUrl(imageUrl: string, location: ImageLocation): string {
  let imageSize: { height: number; width: number };

  const headOfString = imageUrl.substring(0, 40);
  const matches = headOfString.match(/^data:([\w//]){0,20};base64/gm);
  if (matches && matches.length > 0) {
    return imageUrl;
  }

  switch (location) {
    case ImageLocation.MainPhoto:
      imageSize = MAIN_PHOTO_SIZES;
      break;
    case ImageLocation.GalleryPhoto:
      imageSize = GALLERY_PHOTO_SIZES;
      break;
    default:
      throw Error('Unknown image location');
  }

  const imageParams = [CLOUDINARY_SHARPEN, CLOUDINARY_QUALITY, CLOUDINARY_CROPPING, CLOUDINARY_KEEP_ATTRIBUTION];

  if (imageSize.height) {
    imageParams.push(CLOUDINARY_HEIGHT + imageSize.height);
  }

  if (imageSize.width) {
    imageParams.push(CLOUDINARY_WIDTH + imageSize.width);
  }

  const imageId = imageUrl.split('/').reverse()[0];

  return config.cloudinaryApi.replace('{params}', imageParams.join(',')).replace('{image}', imageId);
}
